import { useNavigate } from "react-router-dom"

import type { IPart } from "~/containers/Proposal/Setup/Form/setup-steps-types"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"

import { ContractStatusModalContainer } from "./ContractStatusModalContainer"

const ContractStatus: IPart[`form`] = () => {
  const proposal = useProposalContext()
  const navigate = useNavigate()

  const handleCloseModal = (): void => {
    navigate(`/proposal/${proposal.local.slug}/setup/contract-signing`)
  }

  return (
    <ContractStatusModalContainer isOpen={true} onClose={handleCloseModal} />
  )
}

export default ContractStatus
